import { createReducer, on } from '@ngrx/store';

import * as StartActions from '../actions/start.actions';

export const featureKey = 'start';

/**
 * @ngrx/entity provides a predefined interface for handling
 * a structured dictionary of records. This interface
 * includes an array of ids, and a dictionary of the provided
 * model type by id. This interface is extended to include
 * any additional interface properties.
 */
export interface State {
  loading: boolean;
}

/**
 * getInitialState returns the default initial state
 * for the generated entity state. Initial state
 * additional properties can also be defined.
 */
export const initialState: State = {
  loading: true
};

export const reducer = createReducer(
  initialState,
  on(StartActions.init, (state) => ({...state, loading: true})),
  on(StartActions.initSuccess, (state) => ({...state, loading: false})),
  on(StartActions.loading, (state, { loading }) => ({...state, loading})),
);
